import React from 'react';
import useAutoInputRef from './utils/useAutoInputRef';
import useAutoInputStyles from './utils/useAutoInputStyles';
const AutoInput = ({ name, placeholder, isFocused, handleFocus, handleBlur, handleKeyDown, handleChange, showCreateNewLabel, isLoading = false }) => {
    const { ref, onBlur } = useAutoInputRef(name, isFocused);
    const styles = useAutoInputStyles();
    const mergedHandleBlur = (event) => {
        handleBlur();
        onBlur(event);
    };
    const modifiedStyles = React.useMemo(() => {
        if (isLoading) {
            return {
                ...styles,
                paddingLeft: '70px',
                boxSizing: 'border-box',
                background: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100"><circle cx="15" cy="24" r="5" fill="8d99ae"><animate attributeName="opacity" begin=".1" dur="1s" repeatCount="indefinite" values="0;1;0"/></circle><circle cx="34" cy="24" r="5" fill="8d99ae"><animate attributeName="opacity" begin=".2" dur="1s" repeatCount="indefinite" values="0;1;0"/></circle><circle cx="54" cy="24" r="5" fill="8d99ae"><animate attributeName="opacity" begin=".3" dur="1s" repeatCount="indefinite" values="0;1;0"/></circle></svg>') no-repeat`
            };
        }
        if (showCreateNewLabel) {
            return {
                ...styles,
                paddingLeft: '70px',
                boxSizing: 'border-box',
                background: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="70" height="30"><text x="12" y="29" style="font: bold 16px sans-serif;">Create </text></svg>') no-repeat`
            };
        }
        return { ...styles, padding: '0 2.4rem 0 2.4rem' };
    }, [showCreateNewLabel, styles]);
    return (React.createElement("input", { type: "text", name: name, id: name, style: modifiedStyles, 
        // defaultValue={isNavigated ? suggestedValue : enteredValue}
        onChange: handleChange, onKeyDown: handleKeyDown, onFocus: handleFocus, onBlur: mergedHandleBlur, ref: ref, "data-testid": "comboinput", placeholder: placeholder }));
};
export default AutoInput;
//# sourceMappingURL=AutoInput.js.map